import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  rounded: {
    borderRadius: theme.shape.borderRadius,
  },
}))

export default useStyles
